module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/catstr-abf3185513a5acb906bb78f03be573a7.png";